import { industryFromGooglePlace, industryLabel, normalizeIndustry } from "../../shared/industries.js";

export * from "../../shared/industries.js";

export function industryLabelForPlaceSelection(place, currentIndustry = "", { preserveExisting = false } = {}) {
  const existing = preserveExisting ? normalizeIndustry(currentIndustry) : "";
  const industry = existing || industryFromGooglePlace(place);
  // An unknown Google category must leave the required form field empty.
  return industry ? industryLabel(industry) : "";
}
